import { Button, Space } from 'antd'

import { useDocumentDrawing } from './useDocumentDrawing'

type DrawingControls = Pick<
  ReturnType<typeof useDocumentDrawing>,
  | 'canDraw'
  | 'isDrawing'
  | 'cancelDrawing'
  | 'startDrawing'
  | 'canCrop'
  | 'startCrop'
>

export const DocumentDrawingControls = ({
  drawing,
  drawLabel,
  cropLabel,
}: {
  drawing: DrawingControls
  drawLabel?: string
  cropLabel?: string
}) => {
  const handleDrawClick = () => {
    if (drawing.isDrawing) drawing.cancelDrawing()
    else drawing.startDrawing()
  }

  return (
    <Space wrap>
      {drawLabel && (
        <Button
          disabled={!drawing.canDraw}
          type={drawing.isDrawing ? 'default' : 'primary'}
          onClick={handleDrawClick}>
          {drawing.isDrawing ? 'Cancel drawing' : drawLabel}
        </Button>
      )}
      {cropLabel && (
        <Button disabled={!drawing.canCrop} onClick={drawing.startCrop}>
          {cropLabel}
        </Button>
      )}
    </Space>
  )
}
